import React, { useRef, useState } from "react";
import { UploadCloud, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, imageUrl } from "@/lib/api";

export default function ImageUpload({ value, onChange, label = "Image", testid = "image-upload" }) {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <label className="block text-xs font-oswald tracking-widest text-zinc-400 uppercase mb-1.5">{label}</label>
      {value ? (
        <div className="relative inline-block">
          <img src={imageUrl(value)} alt="" className="h-32 w-32 object-cover rounded-lg border border-[#27272A]" />
          <button type="button" data-testid={`${testid}-remove`} onClick={() => onChange("")} className="absolute -top-2 -right-2 bg-red-600 rounded-full p-1 text-white"><X size={14} /></button>
        </div>
      ) : (
        <button type="button" data-testid={testid} onClick={() => inputRef.current?.click()} disabled={uploading} className="h-32 w-32 rounded-lg border-2 border-dashed border-[#27272A] flex flex-col items-center justify-center gap-1 text-zinc-500 hover:border-[#D4AF37] hover:text-[#D4AF37]">
          {uploading ? <Loader2 className="animate-spin" size={22} /> : <><UploadCloud size={22} /><span className="text-[10px]">Upload</span></>}
        </button>
      )}
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
    </div>
  );
}
